angular.module('app').controller('FranchiseCtrl', function($controller, $scope, $rootScope, $http, $mdDialog, $mdToast, $sce, $timeout, appUtils) {
    "ngInject";

    var main = this;

    main.name = 'franchise';
    main.defaults = {
        'address': {},
        'upload_accounts': [],
        'default_equipment_lists': {},
        'tax_authorities': [],
        'allowed_cards': [],
        'paypal_methods': [],
        'signature_social_links': {}
    };

    // Fixes height issue with initial load of textarea
    $scope.$watch('main.equipment_session_type', function() {
        $scope.$broadcast('md-resize-textarea');
    });

    main.removeUser = function(user) {
        $http.put('/api/v1/admin/user/' + user.id, {'franchise_id': null}).then(function() {
            $rootScope.util.remove(user, null, main.item.users);
        });
    };

    main.connectWhenIWork = function() {
        $rootScope.util.quickDialog(
            function() {
                var dialogScope = this;
                this.done = function() {
                    $http.post(
                        '/api/v1/admin/franchise/' + main.id + '/when-i-work/connect',
                        {'email': dialogScope.email, 'password': dialogScope.password}
                    ).then(function(response) {
                        $mdDialog.hide();
                        main.item.has_when_i_work_token = true;
                        var note = $mdToast.simple().textContent("Connected");
                        $mdToast.show(note);
                    });
                }
            },
            'connect-when-i-work.html',
            { item: main.item }
        );
    }

    function fetchSignaturePreview(fields) {
        return $http.post('/api/v1/admin/franchise/signature-preview', {
            'signature_headshot_url': fields.signature_headshot_url,
            'signature_text': fields.signature_text,
            'signature_social_links': fields.signature_social_links
        });
    }

    main.refreshSignaturePreview = function() {
        fetchSignaturePreview(main.item).then(function(response) {
            main.signaturePreview = response.data.html ? $sce.trustAsHtml(response.data.html) : null;
        });
    };

    $scope.$on('model-loaded', main.refreshSignaturePreview);

    main.editSignature = function() {
        $rootScope.util.quickDialog(
            function($scope) {
                "ngInject";
                var dialog = this;

                dialog.draft = {
                    'signature_headshot_url': main.item.signature_headshot_url,
                    'signature_text': main.item.signature_text,
                    'signature_social_links': angular.copy(main.item.signature_social_links || {})
                };

                var pending = null;
                dialog.refreshPreview = function() {
                    if(pending !== null) {
                        $timeout.cancel(pending);
                    }
                    pending = $timeout(function() {
                        pending = null;
                        fetchSignaturePreview(dialog.draft).then(function(response) {
                            dialog.preview = $sce.trustAsHtml(response.data.html);
                        });
                    }, 300);
                };
                $scope.$watch('main.draft', dialog.refreshPreview, true);

                dialog.uploadHeadshot = function(file) {
                    if(file === null) {
                        return;
                    }
                    if(file.size > 1024 * 1024) {
                        appUtils.toast('Headshot must be under 1MB. Try a 256x256 PNG.');
                        return;
                    }
                    dialog.uploading = true;
                    $http.post(
                        '/api/v1/admin/email/upload',
                        {'extension': file.name.split('.').pop()}
                    ).then(function(response) {
                        appUtils.fileReaderUpload(
                            response.data.upload_url, response.data.content_type, file
                        ).then(function() {
                            dialog.draft.signature_headshot_url = response.data.filename;
                            dialog.uploading = false;
                        }, function() {
                            dialog.uploading = false;
                        });
                    }, function() {
                        dialog.uploading = false;
                    });
                };

                dialog.removeHeadshot = function() {
                    dialog.draft.signature_headshot_url = null;
                };

                dialog.cancel = function() {
                    $mdDialog.cancel();
                };

                dialog.done = function() {
                    angular.extend(main.item, dialog.draft);
                    main.refreshSignaturePreview();
                    $mdDialog.hide();
                    appUtils.toast('Signature updated. Click save to make it permanent.');
                };
            },
            'franchise-signature.html',
            { item: main.item }
        );
    };

    main.loadWiw = appUtils.loadWiw;

    main.updateWhenIWorkAttrs = function(user) {
        if(user.when_i_work_id == '') {
            user.when_i_work_id = null;
        }
        $http.put(
            '/api/v1/admin/user/' + user.id,
            {
                'when_i_work_id': user.when_i_work_id,
                'when_i_work_color': user.when_i_work_color,
                'when_i_work_assistant_color': user.when_i_work_assistant_color,
                'when_i_work_runner_color': user.when_i_work_runner_color,
            }
        )
    }

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    // every send time the server accepts: 8:00 AM to 8:00 PM in 15 minute steps
    main.sendTimeOptions = [];
    for(var minutes = 8 * 60; minutes <= 20 * 60; minutes += 15) {
        var hours = Math.floor(minutes / 60);
        var mins = minutes % 60;
        main.sendTimeOptions.push({
            value: (hours < 10 ? '0' : '') + hours + ':' + (mins < 10 ? '0' : '') + mins,
            label: (hours % 12 || 12) + ':' + (mins < 10 ? '0' : '') + mins + (hours < 12 ? ' AM' : ' PM')
        });
    }
});
